module.exports = __webpack_public_path__ + "static/media/auditoriumP.20c67169.jpg";